import { render, staticRenderFns } from "./setStyle.vue?vue&type=template&id=bd532a54&scoped=true"
import script from "./setStyle.vue?vue&type=script&lang=js"
export * from "./setStyle.vue?vue&type=script&lang=js"
import style0 from "./setStyle.vue?vue&type=style&index=0&id=bd532a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd532a54",
  null
  
)

export default component.exports